import { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = css`
  display: block;
  width: 100%;
  padding: 55px 0 0 0;

  ${Media.lg`
    padding: 55px 0 0 0;
  `}

  ${Media.md`
    padding: 25px 0 0 0;
  `}

  ${props =>
    props.withBigPaddingBottom &&
    css`
      padding: 0 0px 480px 0;
      ${Media.lg`
        padding: 0;
      `}

      ${Media.md`
        padding: 0;
      `}
    `}
`;

export const Container = css`
  display: block;
  max-width: 1425px;
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
  ${props =>
    props.widerTheme &&
    css`
      max-width: 1550px;
    `}
  ${props =>
    props.narrowerTheme &&
    css`
      max-width: 1248px;
    `}
  ${props =>
    props.backgroundAndPadding &&
    css`
      max-width: 1218px;
      padding: ${props => props.theme.paddingDefault || '0 15px'};
      background: ${props => props.theme.background || 'transparent'};
      border-radius: ${props => props.theme.borderRadius || '0'};
      ${Media.lg`
        padding: ${props => props.theme.paddingLg || '0 15px'};
      `}

      ${Media.md`
        padding: ${props => props.theme.paddingMd || '0 15px'};
      `}
    `}
`;

export const Content = css`
  display: grid;
  grid-template-columns: 1fr minmax(240px, 330px);
  grid-gap: 0 15px;
  ${props =>
    props.narrowerTheme &&
    css`
      grid-template-columns: 1fr minmax(240px, 372px);
    `}
  ${props =>
    props.orientation === 'invert' &&
    css`
      grid-template-columns: minmax(240px, 330px) 1fr;
    `}
  ${props =>
    props.orientation === 'invert' &&
    props.narrowerTheme &&
    css`
      grid-template-columns: minmax(240px, 372px) 1fr;
    `}

  ${props =>
    props.aside === false &&
    css`
      grid-template-columns: 1fr;
    `}

  ${Media.md`
    grid-template-columns: 1fr;
  `}
`;

export const Main = css`
  display: block;
  width: 100%;
  min-width: 720px;
  order: 1;

  ${props =>
    props.orientation === 'invert' &&
    css`
      order: 2;
    `}

  ${props =>
    props.narrowerTheme &&
    css`
      min-width: 600px;
    `}

  ${Media.lg`
    min-width: 100%;
  `}

  ${Media.md`
    order: 1;
  `}
`;

export const Aside = css`
  display: block;
  max-width: 330px;
  ${props =>
    props.narrowerTheme &&
    css`
      max-width: 372px;
    `}
  min-width: 240px;
  width: 100%;
  order: 2;

  ${props =>
    props.orientation === 'invert' &&
    css`
      order: 1;
    `}

  ${Media.lg`
    max-width: 330px;
    ${props =>
      props.narrowerTheme &&
      css`
        max-width: 372px;
      `}
  `}

  ${Media.md`
    max-width: 330px;
    margin: 0 auto;
    order: 2;
    ${props =>
      props.narrowerTheme &&
      css`
        max-width: 372px;
      `}
  `}

  ${Media.sm`
    max-width: 100%;
  `}
`;
